/**
 * Validação de data de nascimento no cadastro em lote.
 *
 * true  → data obrigatória no formato DD/MM/YYYY.
 * false → vazio, "-" e equivalentes não impedem o cadastro;
 *         se vier uma data válida, ela é gravada no Person.
 */
export const REQUIRE_BATCH_PERSON_BIRTH_DATE = false;

const BLANK_BIRTH_DATE_TOKENS = new Set([
  "",
  "-",
  "--",
  ".",
  "n/a",
  "na",
  "null",
  "none",
  "s/n",
  "sn",
  "nao informado",
  "não informado",
]);

/** Data ausente ou placeholder (só vale quando a validação está desligada). */
export function isBlankBirthDateValue(raw: string): boolean {
  return BLANK_BIRTH_DATE_TOKENS.has(raw.trim().toLowerCase());
}
